import * as types from "../../constants/types";

export const getCompany = () => {
  return {
    type: types.GET_COMPANY_BEGIN,
  };
};
